import { isEmpty } from '../helpers/paymentKiosk';
import { ID_SCAN_REQUEST, ID_SCAN_CANCEL, ID_SCAN_RESPONSE, requestIdScan, setErrorIdScan } from '../reducers/paymentKioskReducer';
import { paymentKioskHub, getPaymentKioskId } from '../services/paymentKiosk';
import { signInById } from '../actions/login';
import { isUser } from '../reducers/userReducer';
import { isIdScanActive, isHubConnected } from '../selectors/paymentKioskSelectors';

export const paymentKioskMiddleware = ({ dispatch, getState }) => next => action => {
  let currentState = null;
  let paymentKioskId = null;

  switch (action.type) {
    case ID_SCAN_REQUEST:
      currentState = getState();

      if (!isIdScanActive(currentState)) {
        console.warn('ID_SCAN_REQUEST: ID scan is inactive');

        break;
      }

      if (isUser(currentState)) {
        console.warn('ID_SCAN_REQUEST: User already logged in');

        break;
      }

      paymentKioskId = getPaymentKioskId();

      if (isEmpty(paymentKioskId)) {
        console.warn('ID_SCAN_REQUEST: Payment Kiosk settings are missing');

        break;
      }

      if (!isHubConnected(currentState)) {
        console.warn('ID_SCAN_REQUEST: Cannot connect to message hub');

        break;
      }

      console.info(`ID_SCAN_REQUEST: Invoking ScanDriverLicense method on message hub, arguments: ${paymentKioskId}`);

      paymentKioskHub.invokeMethod('ScanDriverLicense', paymentKioskId);
      break;

    case ID_SCAN_CANCEL:
      currentState = getState();
      
      paymentKioskId = getPaymentKioskId();

      if (isEmpty(paymentKioskId)) {
        console.warn('ID_SCAN_CANCEL: Payment Kiosk settings are missing');

        break;
      }

      if (!isHubConnected(currentState)) {
        console.warn('ID_SCAN_CANCEL: Cannot connect to message hub');

        break;
      }

      console.info(`ID_SCAN_CANCEL: Invoking CancelScanDriverLicense method on message hub, arguments: ${paymentKioskId}`);

      paymentKioskHub.invokeMethod('CancelScanDriverLicense', paymentKioskId);
      break;

    case ID_SCAN_RESPONSE:
      console.info(`ID_SCAN_RESPONSE: Received ${JSON.stringify(action.payload)} payload`);

      currentState = getState();

      if (!isIdScanActive(currentState)) {
        console.warn('ID_SCAN_RESPONSE: ID scan is inactive');

        break;
      }

      if (isUser(currentState)) {
        console.warn('ID_SCAN_RESPONSE: User already logged in');

        break;
      }

      let isValid = false;

      let driverLicenseId = null;
      let driverLicenseState = null;

      if (action.payload) {
        driverLicenseId = action.payload.id
        driverLicenseState = action.payload.state;

        if (!isEmpty(driverLicenseId) && !isEmpty(driverLicenseState)) {
          isValid = true;
        }
      }

      if (isValid) {
        console.info('ID_SCAN_RESPONSE: Calling signInById method');

        dispatch(signInById(driverLicenseId, driverLicenseState));
      } else {
        console.warn('ID_SCAN_RESPONSE: Calling requestIdScan method');

        dispatch(setErrorIdScan(true));

        setTimeout(() => {
          dispatch(requestIdScan());
        }, 1500);
      }
      break;
  }

  return next(action);
}


// WEBPACK FOOTER //
// ./src/middleware/paymentKioskMiddleware.js